export default __webpack_public_path__ + "static/media/bell.90d11239.svg";